import cookie from "./_cookie";

const recent = document.querySelector('.js-get-recently');

if (recent) {
    if(cookie.get('recently-viewed') !== null) {
        async function fetchProducts() {
            const currentProducts = cookie.get('recently-viewed').split(',');

            for (const currentProduct of currentProducts) {
                try {
                    const response = await fetch(`/products/${currentProduct}?section_id=product-block-by-id`);
                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    recent.insertAdjacentHTML('beforeend', doc.querySelector('.js-product-data').innerHTML);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchProducts();
    }

    document.addEventListener('click', event => {
        const $slider = event.target.closest('.js-get-recently-viewed');

        if($slider) {
            const $prev = $slider.querySelector('.js-recently-slider-prev');
            const $next = $slider.querySelector('.js-recently-slider-next');
            const width = $slider.querySelector('.js-slider-track ').querySelector('div').clientWidth;

            $prev.addEventListener('click', () => {
                $slider.querySelector('.js-slider-track ').scrollLeft -= width;
            });
            $next.addEventListener('click', () => {
                $slider.querySelector('.js-slider-track ').scrollLeft += width;
            });
        }
    });


}

export const recentProducts = (newProduct, max, days) => {

    let currentProducts = cookie.get('recently-viewed');

    if (currentProducts && currentProducts !== ''){

        const products = currentProducts.split(',');
        var index = products.indexOf(newProduct);

        if (index !== -1) {
            products.splice(index, 1);
        }

        products.unshift(newProduct);
        products.slice(0, 10);
        cookie.set('recently-viewed', products, 14);

    } else {
        cookie.set('recently-viewed', newProduct, 14);
    }
}